import styled from 'styled-components';

const BaseImage = styled.img`
    vertical-align: middle;
    border-style: none;
`;

export { BaseImage };
